<template>
    <SelectButton
        v-if="metricOptions.length > 1"
        v-model="metric"
        :options="metricOptions"
        :disabled="disabled"
        :allow-empty="false"
        option-label="label"
        option-value="name"
        :pt="ptSelectButton"
        @change="emit('filterChanged')"
    />
</template>

<script setup lang="ts">
import { computed, type ModelRef } from 'vue'
import { useStore } from 'vuex'
import SelectButton from 'primevue/selectbutton'
import { getQuestionTypeOptions } from '@/entities'

interface Props {
    disabled: boolean
    activeMetrics: string[]
    isMultiMetric: boolean
}
const props = withDefaults(defineProps<Props>(), {
    disabled: false,
})

const emit = defineEmits(['filterChanged'])

const store = useStore()
const questionTypes = getQuestionTypeOptions()

const defaultActiveMetric = computed(() => props.activeMetrics[0])
// for possible metric values, see getQuestionTypeOptions() > 'name' property
const metric: ModelRef<string | undefined> = defineModel({
    get(value) {
        return value ?? defaultActiveMetric.value
    },
})

const metricOptions = computed(() => {
    // Does not display select button when empty/They only use one metric type
    if (!props.isMultiMetric) {
        return []
    }
    return questionTypes.filter((questionType) =>
        props.activeMetrics.includes(questionType.name)
    )
})

const ptSelectButton = {
    root: { class: 'filter-select-button' },
}
</script>

<style lang="less" scoped>
@import '@/styles/prime-vue/colours.less';
@import '@/styles/prime-vue/variables.less';
@import '~@/styles/rain/variables.less';

.filter-select-button {
    box-shadow: @shadow-xs;

    :deep(.p-togglebutton) {
        padding: @gutterSpacing-base @gutterSpacing-md;
        box-sizing: border-box;
    }
    :deep(.p-togglebutton-label) {
        color: @text-secondary;
        font-size: @fontSize-base;
        line-height: @lineHeight-base;
    }
}
</style>
